import { makeActionCreator } from '../../../../../utilities'
import { PediatricTraumaScoreConstants } from './pediatricTraumaScore.constants'

export const setTotalScore = makeActionCreator(PediatricTraumaScoreConstants.SET_TOTAL_SCORE, 'ptsTotal')
export const setSize = makeActionCreator(PediatricTraumaScoreConstants.SET_SIZE, 'ptsSize')
export const setAirway = makeActionCreator(PediatricTraumaScoreConstants.SET_AIRWAY, 'ptsAir')
export const setSysBP = makeActionCreator(PediatricTraumaScoreConstants.SET_SYSBP, 'ptsBp')
export const setCns = makeActionCreator(PediatricTraumaScoreConstants.SET_CNS, 'ptsCns')
export const setSkeletalInjury = makeActionCreator(PediatricTraumaScoreConstants.SET_SKELETAL_INJURY, 'ptsSkel')
export const setOpenWounds = makeActionCreator(PediatricTraumaScoreConstants.SET_OPEN_WOUNDS, 'ptsWound')
export const setPtsData = makeActionCreator(PediatricTraumaScoreConstants.SET_PTS_DATA, 'ptsData')
export const resetPtsData = makeActionCreator(PediatricTraumaScoreConstants.RESET_PTS_DATA)
export const savePTSData = makeActionCreator(PediatricTraumaScoreConstants.SAVE_PTS_DATA)
